(() => {
  'use strict';

  const STORAGE_KEY = 'unstainedWishlist';
  const WISHLIST_PAGE_URL = '/pages/favorieten';

  /**
   * Lees de opgeslagen favorieten.
   */
  function getWishlist() {
    try {
      const storedWishlist = localStorage.getItem(STORAGE_KEY);
      const parsedWishlist = storedWishlist
        ? JSON.parse(storedWishlist)
        : [];

      return Array.isArray(parsedWishlist)
        ? parsedWishlist
        : [];
    } catch (error) {
      console.error('UNSTAINED: favorieten konden niet worden gelezen.', error);
      return [];
    }
  }

  /**
   * Sla de favorieten op en werk alle tellers bij.
   */
  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      updateWishlistCounters();
      document.dispatchEvent(
        new CustomEvent('unstained:wishlist-updated', {
          detail: {
            items: items,
            count: items.length
          }
        })
      );
    } catch (error) {
      console.error('UNSTAINED: favorieten konden niet worden opgeslagen.', error);
    }
  }

  /**
   * Controleer of een product al is opgeslagen.
   */
  function hasProduct(productHandle) {
    return getWishlist().some(
      item => item.handle === productHandle
    );
  }

  /**
   * Voeg een product toe of verwijder het.
   */
  function toggleProduct(product) {
    if (!product || !product.handle) {
      console.error('UNSTAINED: ongeldige productgegevens.');
      return false;
    }

    let items = getWishlist();
    const existingIndex = items.findIndex(
      item => item.handle === product.handle
    );

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
      saveWishlist(items);
      return false;
    }

    items.push({
      handle: product.handle,
      title: product.title || '',
      url: product.url || `/products/${product.handle}`,
      image: product.image || '',
      price: product.price || '',
      variants: Array.isArray(product.variants)
        ? product.variants
        : [],
      selectedVariantId: product.selectedVariantId || null,
      addedAt: Date.now()
    });

    saveWishlist(items);
    return true;
  }

  /**
   * Verwijder één product uit de favorieten.
   */
  function removeProduct(productHandle) {
    const items = getWishlist().filter(
      item => item.handle !== productHandle
    );

    saveWishlist(items);
    return items;
  }

  /**
   * Sla de gekozen variant/maat op.
   */
  function updateSelectedVariant(productHandle, variantId) {
    const items = getWishlist();
    const product = items.find(
      item => item.handle === productHandle
    );

    if (!product) return;

    product.selectedVariantId = Number(variantId);
    saveWishlist(items);
  }

  /**
   * Werk het aantal favorieten in de header bij.
   *
   * Elementen met data-unstained-wishlist-count worden automatisch gevuld.
   */
  function updateWishlistCounters() {
    const count = getWishlist().length;

    document
      .querySelectorAll('[data-unstained-wishlist-count]')
      .forEach(counter => {
        counter.textContent = count;
        counter.hidden = count === 0;
        counter.setAttribute(
          'aria-label',
          `${count} ${count === 1 ? 'favoriet' : 'favorieten'}`
        );
      });
  }

  /**
   * Voeg een variant rechtstreeks aan de Shopify-winkelwagen toe.
   */
  async function addVariantToCart(variantId, quantity = 1) {
    if (!variantId) {
      throw new Error('Selecteer eerst een beschikbare maat.');
    }

    const rootUrl =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const response = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Number(quantity) || 1
          }
        ]
      })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Dit product kon niet worden toegevoegd.'
      );
    }

    document.dispatchEvent(
      new CustomEvent('unstained:cart-updated', {
        detail: result
      })
    );

    return result;
  }

  /**
   * Toon een korte, nette melding.
   */
  function showMessage(message, type = 'success') {
    let notification = document.getElementById(
      'unstained-wishlist-notification'
    );

    if (!notification) {
      notification = document.createElement('div');
      notification.id = 'unstained-wishlist-notification';
      notification.setAttribute('role', 'status');
      notification.setAttribute('aria-live', 'polite');
      document.body.appendChild(notification);
    }

    notification.className =
      `unstained-wishlist-notification is-${type}`;

    notification.textContent = message;
    notification.classList.add('is-visible');

    window.clearTimeout(notification.hideTimer);

    notification.hideTimer = window.setTimeout(() => {
      notification.classList.remove('is-visible');
    }, 2400);
  }

  /**
   * Open de favorietenpagina.
   */
  function openWishlistPage() {
    window.location.href = WISHLIST_PAGE_URL;
  }

  /**
   * Maak de functies beschikbaar voor de andere bestanden.
   */
  window.UnstainedWishlist = {
    getItems: getWishlist,
    saveItems: saveWishlist,
    hasProduct,
    toggleProduct,
    removeProduct,
    updateSelectedVariant,
    updateCounters: updateWishlistCounters,
    addVariantToCart,
    showMessage,
    openPage: openWishlistPage,
    pageUrl: WISHLIST_PAGE_URL
  };

  document.addEventListener(
    'DOMContentLoaded',
    updateWishlistCounters
  );

  window.addEventListener('storage', event => {
    if (event.key === STORAGE_KEY) {
      updateWishlistCounters();
    }
  });
})();